module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAARCAYAAAAG/yacAAABNUlEQVQokX3Sr0ufURQG8IM4DKJOsdgV7GJYGBPFYrKJZYJiMPgj7Q/YYGnmLWsRManBqKhrhjXZWBxsML6Gr04tfgyeV65f3nnhwnmec57nPfecNxDF/YDvaOIav7GL4bKuCgbwBxdYxzhGsYxjD2epFLXhDkctXy3vXArfVqID/CsK3uAbfuBjwa+k8GVkMJGJqcTb+JTxbiH8i/eBRkE28KXAfSl8nXgLh23x9PRGxF6BGxHRjIjBxFcR0RG4RXc6baTzEDqxWb0j86fYDtzgc9HSPi5zR1d4lXxPGowFZhIMFMIRTLaM/Swn+rjcU/x6Zk8Ladxfil4k+a5GUOVWK65Mzta0WbV1XnKtrl89/IMVnk+jrudE7Vm0mBjWWluue/R0Fv/ESd1g/jetnRS21+XvAYoLtQh6QhCKAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/contact/地址.png
// module id = vIrA
// module chunks = 1